module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-212.b922f4d.woff2";